/*
 * Mantém a categoria ativa ao navegar do sub-menu de departamento para coleções/produtos:
 * - sublinhado da categoria no menu principal
 * - cor da barra de anúncios (topbar) da categoria
 * - o sub-menu de departamento (guarda-se uma cópia ao visitar a página do departamento)
 * O contexto guarda-se em sessionStorage e perde-se ao clicar no menu principal/logótipo
 * ou ao abrir uma página que não seja de coleção/produto.
 */
(function () {
  var KEY = 'departmentContext';
  var script = document.currentScript;
  var pageType = script ? script.getAttribute('data-page-type') : '';
  var inheritsContext = pageType === 'collection' || pageType === 'product';

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }
  function write(ctx) {
    try {
      if (ctx) sessionStorage.setItem(KEY, JSON.stringify(ctx));
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
  }
  function normalize(path) {
    return (path || '').split('?')[0].replace(/\/+$/, '') || '/';
  }

  var ctx = read();

  // Veio diretamente da página do departamento (banners, slides, qualquer ligação ou navegação por JS)?
  var fromDepartment = false;
  if (ctx && ctx.url && document.referrer) {
    try {
      var ref = new URL(document.referrer);
      fromDepartment = ref.origin === window.location.origin && normalize(ref.pathname) === normalize(ctx.url);
    } catch (e) {}
  }

  var active = !!(inheritsContext && ctx && ctx.url && (ctx.via || fromDepartment));
  if (active && !ctx.via) {
    ctx.via = true;
    write(ctx);
  }

  // Cor da topbar o mais cedo possível (evita "piscar")
  if (active && ctx.accent) {
    var style = document.createElement('style');
    style.id = 'department-context-style';
    style.textContent =
      '.topbar{background-color:rgb(' + ctx.accent + ');' +
      (ctx.accentText ? 'color:rgb(' + ctx.accentText + ');' : '') + '}';
    document.head.appendChild(style);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var subnav = document.querySelector('.department-subnav[data-department-url]');

    if (subnav) {
      // Página de departamento: define o contexto; fica "herdável" assim que se clica no sub-menu
      var wrapper = subnav.closest('.shopify-section');
      ctx = {
        url: normalize(subnav.getAttribute('data-department-url')),
        title: subnav.getAttribute('data-department-title') || '',
        accent: subnav.getAttribute('data-accent') || '',
        accentText: subnav.getAttribute('data-accent-text') || '',
        html: wrapper ? wrapper.outerHTML : '',
        via: false
      };
      write(ctx);
      // Qualquer ligação dentro da página do departamento (sub-menu, banners, coleções, produtos)
      // conta como "entrar a partir deste departamento"
      var mainEl = document.getElementById('MainContent');
      document.addEventListener(
        'click',
        function (event) {
          var link = event.target.closest && event.target.closest('a[href]');
          if (!link || !(mainEl && mainEl.contains(link) || subnav.contains(link))) return;
          var url;
          try {
            url = new URL(link.href, window.location.href);
          } catch (e) {
            return;
          }
          if (url.origin !== window.location.origin || url.pathname === window.location.pathname) return;
          ctx.via = true;
          write(ctx);
        },
        true
      );
      subnav.addEventListener('click', function () {
        ctx.via = true;
        write(ctx);
      });
    } else if (!active) {
      write(null);
    }

    if (active && ctx.html && !(window.Shopify && window.Shopify.designMode)) {
      var main = document.getElementById('MainContent');
      if (main && !document.querySelector('.department-subnav')) {
        main.insertAdjacentHTML('beforebegin', ctx.html);
      }
    }

    if (active) {
      var links = document.querySelectorAll('.header__menu a.menu__item[href]');
      for (var i = 0; i < links.length; i++) {
        var a = document.createElement('a');
        a.href = links[i].getAttribute('href');
        if (normalize(a.pathname) === normalize(ctx.url)) {
          links[i].classList.add('menu__item--active');
          break;
        }
      }
    }

    // Clicar no menu principal ou no logótipo termina o contexto
    var resetLinks = document.querySelectorAll('.header__menu a, .header__logo a');
    for (var j = 0; j < resetLinks.length; j++) {
      resetLinks[j].addEventListener('click', function () {
        write(null);
      });
    }
  });
})();
